<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/banner-ai.png`)})`}">
			<div class="container">
				<h2 class="w-600 title text-left color-white mb--0">DeepSeek企業版</h2>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap sbg" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">DeepSeek企業版</h2>
				<div style="margin-top: 48px; ">
					<p style="font-size: 18px">DeepSeek企業版係打造嘅企業級AI解決方案，透過私有化部署+行業深度適配，解決企業AI落地中嘅數據安全、信創合規、場景匱乏與成本高昂四大痛點，推動生成式AI喺垂直領域嘅深度賦能。</p>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">功能亮點</h2>
				<div class="product product-r">
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">私有化部署</div>
									<div class="t2">
										數據本地存儲、模型訓練與推理均喺企業內網完成，確保敏感數據零外泄<br>
										支援華為昇騰、凌久微GPU等國產硬件；支援容器化/K8s部署
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">全棧信創適配</div>
									<div class="t2">
										兼容國產CPU/GPU、麒麟/統信UOS操作系統、達夢/神州數據庫，通過等保2.0/3.0認證<br>
										適配昇騰910B、寒武紀MLU等國產芯片；支援國密算法
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">場景化賦能引擎</div>
									<div class="t2">
										預置20+行業場景AI工具包，支援低代碼調用<br>
										行業知識圖譜+RAG增強；智能體工作流編排平台
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">一體化成本優化</div>
										<div class="t2">
											動態算力調度（CPU/GPU混合負載）+ MoE稀疏激活架構，推理能耗降低40%，有效降低使用成本<br>
											異構算力融合管理平台；FP8混合精度訓練技術
										</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/ds1.png" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>

		<Separator />

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">差異化優勢</h2>
				<div class="product">
					<div class="pic">
						<img src="@/assets/images/ds2.png" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">安全可控</div>
										<div class="t2">
											從芯片層到應用層全鏈路國產化，滿足央國企信創替代要求
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">開箱即用</div>
										<div class="t2">
											預置船舶/水利行業語料庫、智能體工作流，企業3天可上線基礎場景
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">持續進化</div>
									<div class="t2">
										支援企業私有數據微調模型，迭代專屬行業AI
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">TCO降低</div>
									<div class="t2">
										算力彈性調度+MoE架構，綜合使用成本比公有雲API低60%
									</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<Separator />

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">適用客戶</h2>
				<div class="product product-r">
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">重點行業</div>
										<div class="t2">
											船舶製造、港口物流、水利管理、能源重工、高端裝備研發
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">部署模式</div>
										<div class="t2">
											支援私有雲、混合雲、邊緣節點（如船載終端）
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">生態拓展</div>
										<div class="t2">
											開放API對接用友/金蝶/SAP等主流系統，2025年計劃覆蓋80%央企"AI+"場景
										</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/ds3.png" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>

	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
	name: 'Solution1',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
	mounted() {
		new Swiper(".swiper-container", {
			autoplay: true,
			delay: 2000,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + "</span>";
				},
			},
		});
	}
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/sbg.jpg");
}
.product {
	margin-top: 72px;
	display: flex;
	.pic {
		width: 40%;
		img {
			width: 100%;
		}
	}
	.txt {
		width: 60%;
		.eee {
			width: 90%;
			text-align: left;
			.t1 {
				font-size: 24px;
				font-weight: 600;
				color: #000;
			}
			.t2 {
				margin-top: 12px;
				color: #000;
			}
		}
	}
}
@media only screen and (max-width: 768px) {
	.product {
		flex-direction: column;
		gap: 20px;
		.pic {
			width: 100%;
		}
		.txt {
			width: 100%;
		}

		&.product-r {
			flex-direction: column-reverse;
		}
	}
}
.swiper-container {
	width: 100%;
	.swiper-wrapper {
		width: 100%;
	}
	.swiper-slide {
		width: 100%;
		text-align: center;
		font-size: 18px;
		background: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	:deep(.swiper-pagination) {
		bottom: 30px;
		position: unset;
	}

	:deep(.swiper-pagination-bullet) {
		width: 20px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #000;
		opacity: 1;
		background: rgba(0, 0, 0, 0.2);
	}

	:deep(.swiper-pagination-bullet-active){
		color: #fff;
		background: #007aff;
	}
}
</style>
